import { useMemo } from 'react';

export type RoomAccessType = 'team' | 'shared' | 'knock';

export interface RoomAccessStateEntry {
  type: 'eu.meedio.room.access';
  state_key: '';
  content: { type: RoomAccessType };
}

const ROOM_ACCESS_EVENT_TYPE = 'eu.meedio.room.access' as const;

const useRoomAccessInitialState = (accessType: RoomAccessType): RoomAccessStateEntry =>
  useMemo<RoomAccessStateEntry>(
    () => ({
      type: ROOM_ACCESS_EVENT_TYPE,
      state_key: '',
      content: { type: accessType },
    }),
    [accessType]
  );

export default useRoomAccessInitialState;
